import {
  DoseDispensingProductAvailability,
  DoseDispensingProductHalving,
  DoseDispensingProductSortKey,
  DoseDispensingProductType,
  GetDoseDispensingProductsQueryDto,
} from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../features/infinite-query/util/cleanQueryParams'

type TSortKey = DoseDispensingProductSortKey
type THalving = DoseDispensingProductHalving
type TAvailability = DoseDispensingProductAvailability
type TProductType = DoseDispensingProductType

export const querySortDefaults = (searchParams: URLSearchParams) => ({
  sortOrder:
    searchParams.get('sortOrder') && searchParams.get('sortOrder') === 'desc' ? 'desc' : 'asc',
  sortKey: (searchParams.get('sortKey') ?? 'name') as TSortKey,
})

export const mapSearchParamsToQueryParams = (
  searchParams: URLSearchParams
): GetDoseDispensingProductsQueryDto => {
  const parsedParams = {
    ...querySortDefaults(searchParams),
    search: searchParams.get('search') ?? undefined,
    manufacturerName: searchParams.get('manufacturerName') ?? undefined,
    halving: (searchParams.getAll('halving').length > 0
      ? searchParams.getAll('halving')
      : undefined) as undefined | THalving,
    availableForCustomers: (searchParams.getAll('availableForCustomers').length > 0
      ? searchParams.getAll('availableForCustomers')
      : undefined) as undefined | TAvailability,
    type: (searchParams.getAll('type').length > 0 ? searchParams.getAll('type') : undefined) as
      | undefined
      | TProductType,
  }

  return cleanQueryParams(parsedParams)
}
